/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Build_AssistantsInputs */



/**
* | output |
* | --- |
* | "Build an assistant for my team" |
*
* @param {Uno_Welcome_Suggestion_Build_AssistantsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_build_assistants = /** @type {((inputs?: Uno_Welcome_Suggestion_Build_AssistantsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Build_AssistantsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Assistenten für mein Team bauen")
	return /** @type {LocalizedString} */ ("Build an assistant for my team")
});